import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';

const SettingsContext = createContext();

export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    currencySymbol: '₹' // Default fallback value
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/settings`);
        setSettings({
          currencySymbol: response.data.currency_symbol || '₹' // Use API value or fallback
        });
      } catch (error) {
        console.error('Error fetching settings:', error);
        // Keep the default values if there's an error
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return (
    <SettingsContext.Provider
      value={{
        currencySymbol: settings.currencySymbol,
        loading
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export default SettingsContext; 